import clsx from 'clsx';
import LoadingSpinner from '../../assets/icons/loading-icon.svg?react';
import React from 'react';

interface LoaderProps {
  otherClasses?: string;
  variant?: 'fullscreen' | 'compact';
}

const Loader: React.FC<LoaderProps> = ({
  otherClasses,
  variant = 'fullscreen',
}) => {
  const loaderClasses = clsx(
    otherClasses,
    'bg-neutral-tones-background z-10 flex w-full items-center justify-center',
    {
      'h-full min-h-dvh fixed top-0 left-0': variant === 'fullscreen',
      'min-h-96': variant === 'compact',
    },
  );

  return (
    <div className={loaderClasses} data-testid={`loader-${variant}`}>
      <div className="flex flex-col items-center justify-center gap-4 text-center">
        <LoadingSpinner
          className={clsx('animate-spin', {
            'h-16 w-18': variant === 'compact',
          })}
        />
        <h2
          className={clsx(
            'text-neutral-tones-text -tracking-h2 font-inter-variable',
            {
              'text-md': variant === 'compact',
            },
          )}
        >
          Loading...
        </h2>
      </div>
      {variant === 'fullscreen' && (
        <img
          src="/assets/images/logo.png"
          alt="logo"
          className="absolute -bottom-32 left-2/4 max-w-406 min-w-406 -translate-x-2/4 opacity-[0.07] md:-bottom-644 md:min-w-1000 lg:-right-14 lg:-bottom-56 lg:max-h-1000 lg:w-full lg:max-w-812 lg:min-w-min lg:translate-x-0 lg:rotate-[15deg]"
        />
      )}
    </div>
  );
};

export default Loader;
